var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"text",staticClass:"trunquee",style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.displayText)},on:{"mouseenter":_vm.onEnter,"mouseleave":_vm.onLeave}})}
var staticRenderFns = []

export { render, staticRenderFns }